import { useQuery } from "react-query";
import { API } from "../utils/AxiosInstance";
import { ConfigurationInterface } from "../types/app-config";

export async function fetchAppConfig(): Promise<ConfigurationInterface> {
    const res = {
        data: {
            name: "web",
            program: "",
            system_default: false,
            nav_menu: [],
            permission: {},
            menu_obj: {},
        },
    };
    const { data } = await API.get<ConfigurationInterface>(
        `/app_configurations?dashboard=true`
    ).catch((_) => res);
    return data;
}

export function useAppConfig() {
    return useQuery("app-config", fetchAppConfig, {
        refetchOnWindowFocus: false,
    });
}
